<template>
    <div class="all-box">
        <img src="./imgs/img-1920.jpg" alt="">
    </div>
</template>
        
<script>
export default {
   
}
</script>
<style lang='less' scoped>
.all-box{
    width: 100%;
    height: 2000px;
    img{
        width: 100%;
        height: 774px;
    }

}
</style>